import strToBool from '../utils/strToBool'
export const DISABLE_REPORT_REVISIONS = strToBool(
  process.env.VUE_APP_DISABLE_REPORT_REVISIONS
)
export const FORCE_FULLSTORY = strToBool(process.env.VUE_APP_FORCE_FULLSTORY)
export const FORCE_SENTRY = strToBool(process.env.VUE_APP_FORCE_SENTRY)
export const IDLE_COUNTDOWN_MS = +process.env.VUE_APP_IDLE_COUNTDOWN_MS || false
export const LOAD_REPORT_SHIFTS_ONLY =
  +process.env.VUE_APP_LOAD_REPORT_SHIFTS_ONLY || false
